module.exports = __webpack_public_path__ + "static/img/icon8.9e9745ba.gif";